import React from 'react'
import Facilities from './Facilities'
import Faq from './Faq'
import Header from './Header'
import Steps from './Steps'

const Home = () => {
    return (
        <div>
            <Header />
            <Steps />
            <Facilities />
            <Faq />
        </div>
    )
}

export default Home